<template>
    <div>
        <MedicineCountByDate />
    </div>
</template>

<script>
import MedicineCountByDate from '@/components/medicine/MedicineCountByDate.vue';
export default {
    components: {
        MedicineCountByDate
    },
    name: 'MedicineCountByDateView'
}
</script>